import React from 'react';

const Reports = () => <h2>Reports</h2>;

export default Reports;